module.exports = __webpack_public_path__ + "img/salve.6da0df2c.png";